import { getDrSettingsCacheBuster } from '../utils/drSettingsCache.js';

const KBB_HOST = {
    prod: 'www.kbb.com',
    staging: 'staging.kbb.com',
};

export default async (mmdId, sponsor = '', vehicleType = 'used', useStaging = false) => {
    let drAdminConfig;
    const host = useStaging ? KBB_HOST.staging : KBB_HOST.prod;
    const path = `https://${host}/my-wallet/dr-settings/mmdId`;
    try {
        const query = new URLSearchParams();
        const cacheBuster = getDrSettingsCacheBuster();

        if (sponsor) {
            query.set('sponsor', sponsor);
        }

        if (cacheBuster) {
            query.set('nocache', cacheBuster);
        }

        const queryString = query.toString();
        const search = queryString ? `?${queryString}` : '';
        const endpoint = `${path}/${mmdId}/${vehicleType?.toLowerCase()}${search}`;

		const response = await fetch(endpoint, {
            method: 'GET',
            credentials: 'omit',
            headers: {
                'Accept': 'application/json',
            }
        });
        drAdminConfig = await response.json();
    } catch (err) {
        // eslint-disable-next-line
        console.error('DR ADMIN CONFIG REQUEST FAILED: ', err);
        drAdminConfig = {};
    }
    return drAdminConfig;
}
